import type { MutationKey, QueryKey } from "@tanstack/react-query"

enum EQueryKeyBase {
    ZoomAccount = "CoachZoomAccount",
    MsTeamsAccount = "CoachMsTeamsAccount",
    RelinkAccount = "CoachRelinkAccount"
}

enum EMutationKeyBase {
    DisconnectCalendar = "CoachDisconnectCalendar",
    ConfirmAccountsRelinking = "CoachConfirmAccountsRelinking"
}

const EQueryKey: {
    ZoomAccount(): QueryKey
    MsTeamsAccount(): QueryKey
    RelinkAccounts(): QueryKey
} = {
    ZoomAccount: (): QueryKey => [EQueryKeyBase.ZoomAccount],
    MsTeamsAccount: (): QueryKey => [EQueryKeyBase.MsTeamsAccount],
    RelinkAccounts: (): QueryKey => [EQueryKeyBase.RelinkAccount]
} as const

const EMutationKey: {
    DisconnectCalendar(): MutationKey
    ConfirmAccountsRelinking(): MutationKey
} = {
    DisconnectCalendar: (): QueryKey => [EMutationKeyBase.DisconnectCalendar],
    ConfirmAccountsRelinking: (): QueryKey => [EMutationKeyBase.ConfirmAccountsRelinking]
} as const

const EQueryUrl: {
    ZoomAccount(): string
    MsTeamsAccount(): string
    RelinkAccounts(): string
} = {
    ZoomAccount: (): string => "/api/coach-calendar/zoom-account/",
    MsTeamsAccount: (): string => "/api/coach-calendar/ms-teams-account/",
    RelinkAccounts: (): string => "/api/coach-calendar/profiles/relinking/"
} as const

const EMutationUrl: {
    DisconnectCalendar(profileId: string): string
    ConfirmAccountsRelinking(): string
} = {
    DisconnectCalendar: (profileId: string): string => `/api/coach-calendar/profiles/${profileId}/disconnect/`,
    ConfirmAccountsRelinking: (): string => "/api/coach-calendar/profiles/confirm-relink/"
} as const

export {
    EQueryKey as ECoachCalendarQueryKey,
    EMutationKey as ECoachCalendarMutationKey,
    EQueryUrl as ECoachCalendarQueryUrl,
    EMutationUrl as ECoachCalendarMutationUrl
}
